import { render, staticRenderFns } from "./DocumentTypeList.vue?vue&type=template&id=d966f02a&"
import script from "./DocumentTypeList.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeList.vue?vue&type=style&index=0&id=d966f02a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports